/** Same rule as the player settings handle field: 3–48 letters, numbers, hyphens. */
const PLAYER_HANDLE_PATTERN = /^[a-z0-9-]{3,48}$/;

export const PLAYER_HANDLE_HINT = '3–48 characters: letters, numbers, hyphens.';

/** True when a handle can be saved. Case is ignored; other characters are not rewritten. */
export function isValidPlayerHandle(handle: string): boolean {
  return PLAYER_HANDLE_PATTERN.test(handle.trim().toLowerCase());
}
